<template>
  <div data-testid="instrument-chart-container" class="chart__container">
    <HeadingDisplay
      :head="ticker"
      :title="latestPriceFormatted"
      :subtitle="latestPriceDateFormatted"
    />
    <InstrumentLineChart
      :ticker="ticker"
      :latest-price="latestPrice"
      :latest-price-date="latestPriceDate"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { HeadingDisplay } from '@warrenbrasil/nebraska-web';

import { InstrumentLineChart } from './components/InstrumentLineChart';
import { NumberFormatted, StringFormatted } from '@/modules/trade/types';

@Component({
  components: {
    InstrumentLineChart,
    HeadingDisplay
  }
})
export default class InstrumentChart extends Vue {
  @Prop({ type: String, required: true })
  readonly ticker!: string;

  @Prop({ type: Object, required: true })
  readonly latestPrice!: NumberFormatted;

  @Prop({ type: Object, required: true })
  readonly latestPriceDate!: StringFormatted;

  get latestPriceFormatted() {
    return this.latestPrice.formatted;
  }

  get latestPriceDateFormatted() {
    return this.latestPriceDate.formatted;
  }
}
</script>

<style lang="less" scoped>
.chart__container {
  display: flex;
  flex-direction: column;
}
</style>
